<template>
  <div class="wrapper">

    <side-bar type="sidebar"
              :title="settings.app_name"
              :logo="settings.app_image">
      <user-menu></user-menu>
      <template slot="links">
        <sidebar-item v-if="false"
                      :link="{name: $t('sidebar.links.dashboard'), icon: 'nc-icon nc-app', path: '/dashboard'}">
        </sidebar-item>
        <sidebar-item v-if="$can('admin-jobs-all') || $can('admin-jobboard-all')"
                      :link="{name: $t('sidebar.links.jobs'), icon: 'nc-icon nc-tile-56', path: '/jobs?filter=All'}"/>

        <sidebar-item :link="{name: $t('sidebar.links.candidates'), icon: 'nc-icon nc-single-02', path: '/talent'}">
        </sidebar-item>
        <sidebar-item v-if="$can('admin-users-all') || $can('admin-clients-all')"
                      :link="{name: $t('sidebar.links.contacts'), icon: 'nc-icon nc-badge', path: '/contacts'}">
        </sidebar-item>
        <sidebar-item v-if="$can('admin-jobboard-all')"
                      :link="{name: $t('sidebar.links.content'), icon: 'nc-icon nc-paper', path: '/content'}"/>

        <sidebar-item v-if="$can('admin-orders-view')"
                      :link="{name: $t('sidebar.links.ecommerce'), icon: 'nc-icon nc-money-coins', path: '/ecommerce/orders?filter=Orders'}">
        </sidebar-item>

        <sidebar-item v-if="$can('admin-settings-view')"
                      :link="{name: $t('sidebar.links.settings'), icon: 'nc-icon nc-settings', path: '/settings'}"></sidebar-item>
        <sidebar-item v-if="$can('admin-settings-view')"
                      :link="{name: $t('sidebar.links.reports'), icon: 'nc-icon nc-sound-wave', path: '/reports/jobs-overview'}"></sidebar-item>

      </template>
      <template slot="bottom-links">
        <sidebar-item class="logout__button"
                      @click.stop="onLogout"
                      :link="{name: $t('sidebar.links.logout'), icon: 'nc-icon nc-button-power', path: '/'}">
        </sidebar-item>
      </template>
    </side-bar>

    <sidebar-menu>
      <application-search></application-search>
      <portal-target name="sidebar-menu" slim :transition="{name: 'slide-fade', mode: 'out-in'}">
        <!--
        This component can be located anwhere in your App.
        The slot content of the above portal component will be rendered here.
        -->
      </portal-target>
    </sidebar-menu>

    <div class="main-panel">
      <dashboard-content @click.native="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<script>
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import UserMenu from 'src/components/SidebarPlugin/UserMenu.vue'
  import ApplicationSearch from 'src/views/admin/layout/ApplicationSearch'
  import { mapActions, mapState } from 'vuex'
  import { loadGoogleMaps } from 'src/utils/googleMapsLoader'

  export default {
    components: {
      ApplicationSearch,
      ContentFooter,
      DashboardContent,
      UserMenu,
    },
    computed: {
      ...mapState({
        settings: state => state.config.settings,
        apiKeys: state => state.config.apiKeys
      })
    },
    methods: {
      ...mapActions('language', ['getLanguages']),
      ...mapActions('config', ['getAppSettings', 'getPaymentTypes', 'getTimezones']),
      ...mapActions('user', ['logout']),
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      },
      getInitialData () {
        return Promise.all([
          this.getLanguages(),
          this.getAppSettings(),
          this.getPaymentTypes(),
          this.getTimezones()
        ])
      },
      onLogout() {
        this.logout();
        this.$router.push({ name: 'login' }, () => {
          localStorage.clear()
        });
      }
    },
    async mounted () {
      await this.getInitialData()
      loadGoogleMaps(this.apiKeys.googleMaps)
    }
  }

</script>
<style lang="scss">
  /* Enter and leave animations can use different */
  /* durations and timing functions.              */
  .slide-fade-enter-active {
    transition: all .1s ease;
  }

  .slide-fade-leave-active {
    transition: all .1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slide-fade-leave-to {
    transform: translateX(30px);
    opacity: 0.3;
  }

  .slide-fade-enter
    /* .slide-fade-leave-active below version 2.1.8 */
  {
    transform: translateX(-30px);
    opacity: 0.3;
  }

  .logout__button {
    position: absolute;
    bottom: 10px;
    max-width: 100%;
    @apply pb-2;
  }
  .sidebar .nav li.logout__button.active {
    @apply bg-transparent;
    i {
      @apply text-gray-500;
    }
    &:hover i,
    &:focus i{
      @apply text-gray-400;
    }
  }
</style>
